import { CurrencyPipe, DatePipe, NgClass, registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { MatDialogModule } from '@angular/material/dialog';

import { environment } from '../environments/environment';

// Omnium UI
import { OuiAccordionModule } from 'omnium-ui/accordion';
import { OuiButtonModule } from 'omnium-ui/button';
import { OuiButtonToggle } from 'omnium-ui/button-toggle';
import { OuiChipModule } from 'omnium-ui/chip';
import { OuiDialogModule } from 'omnium-ui/dialog';
import { OuiFileItem } from 'omnium-ui/file-item';
import {
  OuiAutocomplete,
  OuiCheckbox,
  OuiDatePickerModule,
  OuiRadioButton,
  OuiRadioButtonGroup,
  OuiRadioList,
  OuiSelect,
  OuiTextarea,
  OuiTextfield,
} from 'omnium-ui/form-field';
import { OuiIconModule } from 'omnium-ui/icon';
import { OuiLayoutModule, OuiNavButtonModule, OuiNavigationPanelModule } from 'omnium-ui/layout';
import { OuiLoadingModule } from 'omnium-ui/loading';
import { OuiMenuModule } from 'omnium-ui/menu';
import { OuiNumber } from 'omnium-ui/number';
import { OuiPaginatorModule } from 'omnium-ui/paginator';
import { OuiSearchbar } from 'omnium-ui/searchbar';
import { OuiSelectFilter } from 'omnium-ui/select-filter';
import { OuiSlideToggle } from 'omnium-ui/slide-toggle';
import { OuiSnackbarModule } from 'omnium-ui/snackbar';
import { OuiStepper } from 'omnium-ui/stepper';
import { OuiTableModule } from 'omnium-ui/table';
import { OuiTabsModule } from 'omnium-ui/tabs';
import { OuiTagModule } from 'omnium-ui/tag';

import { OuiEtatVide } from 'omnium-ui/etat-vide';
import { OuiTooltipModule } from 'omnium-ui/tooltip';

import { AuthInterceptorInterceptor } from 'src/interceptors/auth-interceptor.interceptor';

import { OuiBanner } from 'omnium-ui/banner';

import { LibModule } from '@lib/lib.module';
import { OuiInfosBulle } from 'omnium-ui/infos-bulle';
import { AddLegacyDocDialogComponent } from 'projects/fiche-conseil-backoffice/src/app/components/admin-page/admin-fiche/add-legacy-doc-dialog/add-legacy-doc-dialog.component';
import { AdminFicheComponent } from 'projects/fiche-conseil-backoffice/src/app/components/admin-page/admin-fiche/admin-fiche.component';
import { FicheConfigTableComponent } from 'projects/fiche-conseil-backoffice/src/app/components/admin-page/admin-fiche/fiche-config-table/fiche-config-table.component';
import { AdminPageComponent } from 'projects/fiche-conseil-backoffice/src/app/components/admin-page/admin-page.component';
import { AllocationTableComponent } from 'src/app/components/admin-page/admin-fichiers-allocation/allocation-table/allocation-table.component';
import { FichiersAllocationComponent } from 'src/app/components/admin-page/admin-fichiers-allocation/fichiers-allocation.component';
import { GraphQLModule } from 'src/app/graphql.module';

import { ApplicationInsightsErrorHandler } from 'finzzle-angular-utils';
import { OuiFileUploader } from 'omnium-ui/file-uploader';
import { FicheDashboardComponent } from 'src/app/components/admin-page/admin-fiche/fiche-dashboard/fiche-dashboard.component';
import { FicheDetailsComponent } from 'src/app/components/admin-page/admin-fiche/fiche-details/fiche-details.component';
import { ActivateConseilConfigComponent } from './components/admin-page/admin-fiche/fiche-config-table/activate-conseil-config/activate-conseil-config.component';
import { DeleteDraftConseilConfigComponent } from './components/admin-page/admin-fiche/fiche-config-table/delete-draft-conseil-config/delete-draft-conseil-config.component';
import { DownloadTemplateComponent } from './components/admin-page/admin-fiche/fiche-config-table/download-template/download-template.component';
import { AddConseilConfigVersionDialogComponent } from './components/admin-page/admin-fiche/fiche-details/add-conseil-config-version-dialog/add-conseil-config-version-dialog.component';
import { AddFichierAllocationDialogComponent } from './components/admin-page/admin-fichiers-allocation/add-fichier-allocation-dialog/add-fichier-allocation-dialog.component';
import { InvestisseurTypePipe } from './pipes/investisseur-type.pipe';
import { TemplateNamePipe } from './pipes/template-name.pipe';

@NgModule({
  declarations: [
    AppComponent,
    AdminPageComponent,
    AdminFicheComponent,
    FichiersAllocationComponent,
    FicheConfigTableComponent,
    AddLegacyDocDialogComponent,
    AllocationTableComponent,
    AddFichierAllocationDialogComponent,
    FicheDetailsComponent,
    FicheDashboardComponent,
    InvestisseurTypePipe,
    AddConseilConfigVersionDialogComponent,
    ActivateConseilConfigComponent,
    DeleteDraftConseilConfigComponent,
    DownloadTemplateComponent,
    TemplateNamePipe,
  ],
  bootstrap: [AppComponent],
  imports: [
    LibModule,
    OuiLayoutModule,
    OuiDatePickerModule,
    OuiIconModule,
    OuiButtonModule,
    OuiTabsModule,
    OuiTagModule,
    OuiTableModule,
    OuiPaginatorModule,
    OuiNavButtonModule,
    OuiNavigationPanelModule,
    OuiRadioButton,
    OuiRadioButtonGroup,
    OuiRadioList,
    OuiInfosBulle,
    OuiStepper,
    OuiSlideToggle,
    OuiSelect,
    OuiLoadingModule,
    OuiSelectFilter,
    OuiAccordionModule,
    OuiTextfield,
    OuiTextarea,
    OuiCheckbox,
    OuiAutocomplete,
    OuiButtonToggle,
    OuiMenuModule,
    OuiSearchbar,
    OuiChipModule,
    OuiNumber,
    OuiBanner,
    OuiEtatVide,
    OuiDialogModule,
    OuiSnackbarModule,
    OuiTooltipModule,
    OuiFileUploader,
    OuiFileItem,
    MatDialogModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    GraphQLModule,
    NgClass,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: HTTP_INTERCEPTORS, multi: true, useClass: AuthInterceptorInterceptor },
    { provide: 'environment', useValue: environment },
    { provide: ErrorHandler, useClass: ApplicationInsightsErrorHandler },
    CurrencyPipe,
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}

registerLocaleData(localeFr, 'fr-FR');
